module.exports = __webpack_public_path__ + "img/logoNest.3e8e07d7.svg";